export type LensPage = "stats" | "proficiencies" | "achievements";

export interface LegacyRedirect {
  page: LensPage;
  hash: string;
}

const ACTIVE_REDIRECT_PAGES: ReadonlySet<LensPage> = new Set<LensPage>(["stats", "proficiencies", "achievements"]);

function safeDecode(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

export function legacyPilotRedirect(hash: string): LegacyRedirect | null {
  const [pathPart, queryString = ""] = hash.replace(/^#/, "").split("?");
  const parts = pathPart.split("/").filter(Boolean);
  if ((parts[0] !== "pilots" && parts[0] !== "stats") || !parts[1]) return null;
  // The bare profile, #/pilots/:uid, is a page in its own right.
  if (parts[0] === "pilots" && !parts[2]) return null;

  let page: LensPage = "stats";
  if (parts[0] === "pilots") {
    if (parts[2] === "proficiencies" || parts[2] === "skills") page = "proficiencies";
    else if (parts[2] === "achievements") page = "achievements";
  }

  const params = new URLSearchParams();
  params.set("pilot", safeDecode(parts[1]));
  new URLSearchParams(queryString).forEach((value, key) => {
    if (key !== "pilot") params.append(key, value);
  });
  return { page, hash: `#/${page}?${params.toString()}` };
}

export function activeLegacyRedirect(hash: string): string | null {
  const redirect = legacyPilotRedirect(hash);
  return redirect && ACTIVE_REDIRECT_PAGES.has(redirect.page) ? redirect.hash : null;
}
